import Header from "@/components/Header";
import ProjectsSection from "@/components/ProjectsSection";
import InstagramSection from "@/components/InstagramSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import SEOHead from "@/components/SEOHead";

const GalleryPage = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="أعمالنا في الديكورات والتشطيبات | معرض صور بالرياض"
        description="شاهدوا معرض أعمالنا في الديكورات والتشطيبات بالرياض — مشاريع فلل وشقق ومكاتب منفذة بأعلى معايير الجودة والإتقان."
        canonical="/gallery"
        schema={{
          "@context": "https://schema.org",
          "@type": "ImageGallery",
          "name": "معرض أعمال حسن عبدالله للمقاولات والديكورات",
          "description": "مشاريع ديكورات وتشطيبات منفذة في الرياض — فلل وشقق ومكاتب.",
          "url": "https://decoriyaa.com/gallery",
          "publisher": {
            "@type": "LocalBusiness",
            "name": "حسن عبدالله للمقاولات والديكورات"
          }
        }}
      />
      <Header />
      <div className="pt-20">
        <ProjectsSection />
        <InstagramSection />
      </div>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default GalleryPage;
